import {Keys} from "@/constants/key";
import {Tr} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Scene} from "phaser";
import SpriteUtils from "@/utils/sprite-utils";
import Container = Phaser.GameObjects.Container;

export class BackTriangle extends Container {

    constructor(scene: Scene, x: number, y: number, callback: () => unknown, txt: string) {
        super(scene);
        this.setDepth(1000);
        this.x = x;
        this.y = y;

        let backText = TextUtils.addTextByFamily(scene, txt, 0, -45,
            '#f7e4a2', 14, 'normal', 110, Fonts.MYRIADPRO_REGULAR);
        backText.setStroke('#000000', 1);

        let button = SpriteUtils.addSprite(scene, 0, 0, Keys.GREEN_TRIANGLE);

        button.setInteractive().on('pointerup', () => {
            callback();
        });

        this.add([backText, button]);

        let self = this;
        scene.tweens.chain({
            targets: self,
            loop: -1,
            tweens: [
                {
                    duration: 3000,
                    props: {
                        x: { value: self.x-3, ease: 'Sine.InOut' }
                    }
                },{
                    duration: 3000,
                    props: {
                        x: { value: self.x+3, ease: 'Sine.InOut' }
                    }
                }
            ]
        });
    }

}
